import { ConfigResponse } from "api/shared";

export function getPageConfiguration(
  config: ConfigResponse,
  page: keyof ConfigResponse["pageConfiguration"],
  key?: string
) {
  const pageConfiguration = config.pageConfiguration[page];

  return pageConfiguration && key
    ? Object.entries(pageConfiguration)
        .find(([c]) => c.toLowerCase() === key.toLowerCase())
        ?.pop()
    : pageConfiguration;
}
